<aside class="sidebar" [class.sidebar--collapsed]="collapsed()">
  <!-- Logo -->
  <div class="logo-section">
    <div class="logo-box">
      <mat-icon>shield</mat-icon>
    </div>
    @if (!collapsed()) {
      <span class="logo-text">Dime Admin.</span><span class="version">v1.0</span>
    }
  </div>

  <!-- Grupos de navegación -->
  <nav class="nav-content">
    @for (group of filteredGroups(); track group.title) {
      <div class="nav-group">
        @if (!collapsed()) {
          <div class="group-title">{{ group.title }}</div>
        }

        @for (item of group.items; track item.title) {
          <!-- Item con submenú (acordeón) -->
          @if (item.children && item.children.length > 0) {
            <div class="accordion-wrap" [class.accordion-wrap--open]="isOpen(item.title)">
              <!-- Cabecera del acordeón -->
              <button
                class="nav-item nav-item--accordion"
                [class.nav-item--open]="isOpen(item.title)"
                [matTooltip]="collapsed() ? item.title : ''"
                matTooltipPosition="right"
                (click)="toggleItem(item.title)"
              >
                <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>

                @if (!collapsed()) {
                  <span class="nav-label">{{ item.title }}</span>
                  <mat-icon class="chevron-icon">
                    {{ isOpen(item.title) ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                }
              </button>

              <!-- Submenú colapsable -->
              @if (!collapsed()) {
                <div class="submenu" [class.submenu--open]="isOpen(item.title)">
                  @for (child of item.children; track child.title) {
                    <a class="submenu-item" [routerLink]="child.route" routerLinkActive="submenu-item--active">
                      <span class="submenu-dot"></span>
                      {{ child.title }}
                    </a>
                  }
                </div>
              }
            </div>
          } @else {
            <!-- Item simple -->
            <a
              class="nav-item"
              [routerLink]="item.route"
              routerLinkActive="nav-item--active"
              [routerLinkActiveOptions]="{ exact: item.route === '/' }"
              [matTooltip]="collapsed() ? item.title : ''"
              matTooltipPosition="right"
            >
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>

              @if (!collapsed()) {
                <span class="nav-label">{{ item.title }}</span>
              }
            </a>
          }
        }
      </div>
    }
  </nav>
</aside>
